<template>
  <div
      class="overlay"
      :class="{ 'overlay-visible': isOpen }"
      @click="$emit('close-extra-bottom-sheet')"
  >
    <div
        class="sheet-container"
        :class="{ 'sheet-visible': isOpen }"
        @click.stop
    >
      <img src="@/tarot_box/pages/box_result_v2/assets/xbutton.svg" class="close-button" @click="$emit('close-extra-bottom-sheet')"/>

      <div class="main-graphic">
        <img src="https://imagedelivery.net/rz4kIC2FHjrPe9mGQi46Fw/049a2a6d-0001-4891-298a-7c9fd9358900/public"/>
        <!-- 롤링 텍스트를 조건부로 렌더링 -->
        <transition name="fade" mode="out-in" v-if="shouldShowRollingText">
          <p :key="currentRollingText">"{{ currentRollingText }}"</p>
        </transition>
      </div>
      <textarea
          ref="textInput"
          :value="localValue"
          @input="handleInput"
          @blur="handleBlur"
          class="question-input"
          maxlength="94"
          :placeholder="dynamicPlaceholder"
      ></textarea>

      <div class="bottom-section">
        <div class="clover-info">
          <span class="Title4 Gray6">내 클로버</span>
          <span class="Caption1 Gray9">{{ userClover }}<img src="@/tarot_box/pages/box_result_v2/assets/clover-sm.svg" class="clover-icon" alt="♣"/></span>
        </div>

        <button
            class="submit-button Title2 Gray2"
            :class="{ 'full-width': !showCloverInfo }"
            :disabled="isSubmitDisabled"
            @click="submitQuestion"
        >
          <span v-if="isFirstTime">{{ buttonText }}</span>
          <span v-else>{{ buttonText }}<img src="@/tarot_box/pages/box_result_v2/assets/clover-sm.svg"/>로 결과보기</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import {logEvent} from "@/tarot_box/helper/native_api";

export default {
  name: "BottomSheet.vue",
  props: {
    isOpen: {
      type: Boolean,
      default: false
    },
    modelValue: {
      type: String,
      default: ''
    },
    userClover: {
      type: Number,
      default: 0,
    },
    isFirstTime: {
      type: Boolean,
      default: true
    },
    currentPageIndex: {
      type: Number,
      required: true
    },
    resultPageData: {
      type: Array,
      required: true
    },
    tarotBoxSubject: {
      type: String,
      default: null
    }
  },
  emits: ['close-extra-bottom-sheet', 'update:modelValue', 'submit-question'],
  data() {
    return {
      localValue: '',
      // 주제별 롤링 문구들
      rollingTextsBySubject: {
        '재회': [
          "그 사람이 제일 그리워하는 점은 무엇일까요?",
          "제게 행복했던 순간이 그 사람에게도 행복했을까요?",
          "저희는 서로 닮은 면이 많았나요?",
          "그 사람도 우리 사이가 정말 특별했다고 생각할까요?",
          "제가 했던 말을 지금도 기억하고 있을까요?",
          "그 사람도 아직 헤어짐을 실감하지 못할까요?",
          "이별을 말한 게 진심이 아니었을 수도 있나요?",
          "제가 했던 말 때문에 마음이 완전히 돌아섰나요?",
          "그 사람은 아직 저와 찍은 사진들을 찾아볼까요?",
          "저와 헤어지고 후회가 컸을까요?"
        ],
        '솔로탈출': [
          "주변 아는 사람 중에 인연이 생길 가능성도 있나요?",
          "제가 놓치고 있는 좋은 인연이 있나요?",
          "이번에 만날 사람은 제 운명을 바꿀 사람일까요?",
          "지금 제게 다가오려다 망설이는 사람이 있나요?",
          "연애할 때 안정감과 편안함을 느낄 수 있을까요?",
          "단체 or 일대일 저는 어느 상황에서 더 매력 있나요?",
          "제가 더 매력적으로 보이는 순간은 언제인가요?",
          "저는 첫눈에 반할 타입일까요, 서서히 빠질 타입일까요?",
          "제가 사랑받는 타입일까요, 사랑을 주는 타입인가요?",
          "저는 사람 보는 눈이 있나요?"
        ]
      },
      currentRollingText: '',
      rollingInterval: null,
      // 이미 표시된 문구들을 추적하기 위한 배열
      shownTexts: []
    }
  },
  computed: {
    isSubmitDisabled() {
      return !this.localValue || this.localValue.trim().length === 0;
    },
    buttonText() {
      return this.isFirstTime ? '무료로 결과보기' : '5';
    },
    showCloverInfo() {
      return !this.isFirstTime;
    },
    // tarotBoxSubject에서 첫 번째 키워드 추출
    currentSubject() {
      if (!this.tarotBoxSubject) return null;
      // 콤마로 분리하고 첫 번째 부분을 가져와서 trim
      const firstPart = this.tarotBoxSubject.split(',')[0].trim();
      return firstPart;
    },
    // 현재 주제에 해당하는 롤링 텍스트 배열
    currentRollingTexts() {
      if (!this.currentSubject || !this.rollingTextsBySubject[this.currentSubject]) {
        return [];
      }
      return this.rollingTextsBySubject[this.currentSubject];
    },
    // 롤링 텍스트를 보여줄지 여부
    shouldShowRollingText() {
      return this.currentSubject && this.rollingTextsBySubject[this.currentSubject];
    },
    currentChapter() {
      // 현재 페이지 이전의 가장 가까운 title_page 찾기
      let titlePage = null;
      let chapterIndex = 0;

      // title_page들만 필터링
      const titlePages = this.resultPageData
          .filter(item => item.page_type === 'title_page')
          .sort((a, b) => a.page_index - b.page_index);

      // 현재 페이지보다 작은 인덱스를 가진 마지막 title_page 찾기
      for (let i = 0; i < titlePages.length; i++) {
        if (titlePages[i].page_index < this.currentPageIndex) {
          titlePage = titlePages[i];
          chapterIndex = i;
        } else {
          break;
        }
      }

      // 찾은 title_page가 있으면 챕터 결정
      if (titlePage) {
        // 부록 특별 처리
        if (titlePage.page_title === '부록') {
          return '부록';
        }
        // 일반 챕터
        return `Chapter ${chapterIndex + 1}`;
      }

      // title_page를 찾지 못한 경우 (예외 상황)
      return 'Chapter 1';
    },

    // 동적 placeholder
    dynamicPlaceholder() {
      return `${this.currentChapter}에서 떠오른 궁금증을 풀어보세요`;
    }
  },
  watch: {
    isOpen(newVal) {
      if (newVal) {
        this.$nextTick(() => {
          this.$refs.textInput?.focus();
        });
        // bottom sheet가 열릴 때 롤링 시작
        this.startRolling();
      } else {
        // bottom sheet가 닫힐 때 롤링 중지
        this.stopRolling();
      }
    },
    modelValue(newVal) {
      this.localValue = newVal;
    }
  },
  mounted() {
    this.localValue = this.modelValue;
    // 컴포넌트가 마운트되고 isOpen이 true면 롤링 시작
    if (this.isOpen) {
      this.startRolling();
    }
  },
  beforeUnmount() {
    // 컴포넌트가 언마운트될 때 롤링 중지
    this.stopRolling();
  },
  methods: {
    handleInput(event) {
      this.localValue = event.target.value;
      this.$emit('update:modelValue', this.localValue);
    },
    handleBlur() {
      // OS별 키보드 처리를 위한 blur 이벤트
      if( this.localValue.trim().length > 0 ) {
        logEvent('extra_question_input',{
          question: this.localValue,
          chapter: this.currentChapter,
          subject: this.currentSubject
        })
      }
      this.$emit('update:modelValue', this.localValue);
    },
    submitQuestion(){
      if (this.isSubmitDisabled) return;
      this.$emit('update:modelValue', this.localValue);
      this.$emit('submit-question');
      this.$emit('close-extra-bottom-sheet');
      // 추가적인 제출 로직이 필요하다면 여기에 작성
    },
    // 랜덤하게 다음 텍스트 가져오기
    getRandomText() {
      const texts = this.currentRollingTexts;
      if (texts.length === 0) return '';

      // 모든 텍스트를 다 보여줬다면 초기화
      if (this.shownTexts.length >= texts.length) {
        this.shownTexts = [];
      }

      // 아직 보여주지 않은 텍스트들만 필터링
      const availableTexts = texts.filter(text => !this.shownTexts.includes(text));

      // 랜덤하게 하나 선택
      const randomIndex = Math.floor(Math.random() * availableTexts.length);
      const selectedText = availableTexts[randomIndex];

      // 선택된 텍스트를 shownTexts에 추가
      this.shownTexts.push(selectedText);

      return selectedText;
    },
    // 텍스트 롤링 시작
    startRolling() {
      // 롤링 텍스트를 보여주지 않아야 하는 경우 중단
      if (!this.shouldShowRollingText) return;

      // 이미 롤링 중이면 중복 실행 방지
      if (this.rollingInterval) return;

      // 첫 텍스트 설정
      this.currentRollingText = this.getRandomText();

      // 3초마다 텍스트 변경
      this.rollingInterval = setInterval(() => {
        this.currentRollingText = this.getRandomText();
      }, 3000);
    },
    // 텍스트 롤링 중지
    stopRolling() {
      if (this.rollingInterval) {
        clearInterval(this.rollingInterval);
        this.rollingInterval = null;
      }
      // 롤링이 중지되면 표시된 텍스트 목록 초기화
      this.shownTexts = [];
    }
  }
}
</script>

<style scoped>
/* 기존 스타일 그대로 유지 */
div, textarea{
  box-sizing: border-box;
}
.overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(115, 120, 135, 0);
  z-index: 1000;
  display: flex;
  align-items: flex-end;
  pointer-events: none;
  transition: background-color 0.3s ease-in-out;
}

.overlay-visible {
  background-color: rgba(115, 120, 135, 0.5);
  pointer-events: auto;
}

.sheet-container {
  position: relative;
  width: 100%;
  background-color: #01081D;
  border-radius: 16px 16px 0 0;
  padding: 16px 12px 40px 12px ;
  max-height: 80vh;
  overflow-y: auto;
  transform: translateY(100%);
  transition: transform 0.3s ease-in-out;
  pointer-events: auto;
}

.sheet-visible {
  transform: translateY(0);
}

.close-button {
  position: absolute;
  top: 12px;
  right: 8px;
  background: none;
  border: none;
  color: white;
  cursor: pointer;
  filter: brightness(200%);
}

.main-graphic{
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 20px;
}

.main-graphic img{
  width: 90px;
  height: auto;
}

.main-graphic p {
  color: var(--Gray8);
  font-size: 14px;
  font-family: "KimjungchulMyungjo", serif;
  margin: 0;
  min-height: 20px; /* 텍스트 변경 시 레이아웃 점프 방지 */
}

.question-input {
  width: 100%;
  min-height: 80px;
  padding: 12px 12px 18px;
  background-color: #212B49;
  border-radius: 8px;
  line-height: 1.4;
  color: white;
  font-size: 14px;
  resize: none;
  margin-bottom: 20px;
}

.question-input::placeholder {
  font-family: "KimjungchulMyungjo", serif;
  color: #878FA8;
}

.bottom-section {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 32px;
}

.clover-info {
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: 4px;
}

.clover-info span{
  display: flex;
  align-items: center;
  gap: 4px;
  white-space: nowrap;
}

.submit-button {
  flex: 5;
  padding: 14px 24px;
  background-color: var(--Gray9);
  border-radius: 24px;
  cursor: pointer;
}

.submit-button span {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
}

.submit-button:disabled{
  opacity: 0.4;
  cursor: not-allowed;
  pointer-events: none;
}

/* 페이드 트랜지션 효과 */
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.5s ease;
}

.fade-enter-from, .fade-leave-to {
  opacity: 0;
}

.fade-enter-to, .fade-leave-from {
  opacity: 1;
}
</style>